import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography} from "@mui/material"
import React, {useState} from "react"

import {ConfirmationDialog} from "@indebted/components/ConfirmationDialog"
import {api} from "@indebted/api"
import {useAgent} from "@indebted/hooks/Agent"
import {useNotification} from "@indebted/components/Notification"

function ScheduledPaymentRow({
	paymentArrangementID,
	title,
	amount,
	scheduledDate,
	reload,
}: {
	paymentArrangementID: string
	title: string
	amount: string
	scheduledDate: string
	reload: (delayMs?: number) => void
}) {
	const [agentEmail] = useAgent()
	const {notification} = useNotification()
	const [dialogOpen, setDialogOpen] = useState(false)
	const [cancelling, setCancelling] = useState(false)

	const handleCancel = () => {
		setCancelling(true)
		api.paymentPlan
			.cancel(paymentArrangementID, {AgentEmail: agentEmail})
			.then(() => {
				notification.success("Scheduled payment cancelled successfully.")
				setCancelling(false)
				reload(500)
			})
			.catch((error?: {Message?: string}) => {
				setCancelling(false)
				notification.error(error?.Message ?? "Failed to cancel scheduled payment.")
			})
	}

	return (
		<>
			<ConfirmationDialog
				description="The entire payment arrangement will be cancelled, including this scheduled payment. Do you confirm?"
				isOpen={dialogOpen}
				onCancel={() => setDialogOpen(false)}
				onOK={() => {
					setDialogOpen(false)
					handleCancel()
				}}
			/>
			{/* Always expanded: the scheduled payment details and cancel action stay visible. */}
			<Accordion expanded disableGutters>
				<AccordionSummary sx={{pl: 3}}>
					<Typography variant="body2">{title}</Typography>
				</AccordionSummary>
				<AccordionDetails sx={{pl: 3}}>
					<Box mb={2}>
						<Typography variant="body2">
							<strong>Amount:</strong>
						</Typography>
						<Typography variant="body2" color="textSecondary">
							{amount}
						</Typography>
					</Box>
					<Box mb={2}>
						<Typography variant="body2">
							<strong>Scheduled on:</strong>
						</Typography>
						<Typography variant="body2" color="textSecondary">
							{scheduledDate}
						</Typography>
					</Box>
					<Button
						variant="outlined"
						color="error"
						size="small"
						disabled={cancelling}
						onClick={() => setDialogOpen(true)}
					>
						{cancelling ? "Cancelling…" : "Cancel schedule"}
					</Button>
				</AccordionDetails>
			</Accordion>
		</>
	)
}

export {ScheduledPaymentRow}
